import { NavSection } from './nav-section.model';
import { NavIcons } from './nav-icons';

export const APP_NAV_SECTIONS: NavSection[] = [
  {
    title: 'Mi trabajo',
    profiles: ['agente_ventas'],
    items: [
      {
        label: 'Mi cartera',
        route: '/prospectos',
        icon: NavIcons.users,
        profiles: ['agente_ventas'],
      },
      {
        label: 'Nuevo prospecto',
        route: '/prospectos/nuevo',
        icon: NavIcons.person,
        profiles: ['agente_ventas'],
      },
      {
        label: 'Agenda comercial',
        route: '/prospectos/agenda',
        icon: NavIcons.calendar,
        profiles: ['agente_ventas'],
      },
    ],
  },
  {
    title: 'Cartera y seguimiento',
    items: [
      {
        label: 'Cartera comercial',
        route: '/cartera',
        icon: NavIcons.users,
        profiles: ['agente_ventas', 'jefe_comercial', 'director', 'administrador'],
      },
      {
        label: 'Embudo comercial',
        route: '/funnel',
        icon: NavIcons.chart,
        profiles: ['agente_ventas', 'jefe_comercial', 'director'],
      },
      {
        label: 'Reportes y paneles',
        route: '/reportes',
        icon: NavIcons.chart,
        profiles: ['agente_ventas', 'jefe_comercial', 'director', 'administrador'],
      },
      {
        label: 'SLA de primer contacto',
        route: '/sla',
        icon: NavIcons.clock,
        profiles: ['agente_ventas', 'jefe_comercial', 'director', 'administrador', 'soporte'],
      },
    ],
  },
  {
    title: 'Asignación',
    items: [
      {
        label: 'Bandeja de leads',
        route: '/asignacion/bandeja',
        icon: NavIcons.users,
        profiles: ['jefe_comercial', 'administrador'],
      },
      {
        label: 'Disponibilidad de agentes',
        route: '/disponibilidad',
        icon: NavIcons.building,
        profiles: ['jefe_comercial', 'director', 'administrador', 'soporte'],
      },
      {
        label: 'Excepciones de asignación',
        route: '/asignacion/excepciones',
        icon: NavIcons.block,
        profiles: ['jefe_comercial', 'administrador', 'soporte'],
      },
      {
        label: 'Reglas de asignación',
        route: '/asignacion/reglas',
        icon: NavIcons.settings,
        profiles: ['administrador', 'soporte'],
      },
      {
        label: 'Reasignación automática',
        route: '/asignacion/reasignacion-automatica',
        icon: NavIcons.person,
        profiles: ['agente_ventas', 'jefe_comercial', 'director', 'administrador', 'soporte'],
      },
      {
        label: 'Motivos de reasignación',
        route: '/asignacion/motivos-reasignacion',
        icon: NavIcons.document,
        profiles: ['administrador'],
      },
    ],
  },
  {
    title: 'Campañas y cargas',
    items: [
      {
        label: 'Campañas',
        route: '/campanas',
        icon: NavIcons.chart,
        profiles: ['agente_ventas', 'jefe_comercial', 'director', 'administrador', 'soporte'],
      },
      {
        label: 'Catálogos de campaña',
        route: '/campanas/catalogos',
        icon: NavIcons.bank,
        profiles: ['agente_ventas', 'jefe_comercial', 'director', 'administrador', 'soporte'],
      },
      {
        label: 'Cargas masivas',
        route: '/cargas-masivas',
        icon: NavIcons.download,
        profiles: ['administrador', 'jefe_comercial'],
      },
      {
        label: 'Recepciones API',
        route: '/recepciones',
        icon: NavIcons.search,
        profiles: ['agente_ventas', 'jefe_comercial', 'director', 'administrador', 'soporte'],
      },
      {
        label: 'Recupero',
        route: '/recupero',
        icon: NavIcons.search,
        profiles: ['administrador'],
      },
    ],
  },
  {
    title: 'Administración',
    profiles: ['administrador'],
    items: [
      {
        label: 'Catálogos comerciales',
        route: '/catalogos-comerciales',
        icon: NavIcons.settings,
        profiles: ['administrador'],
      },
      {
        label: 'Pipeline por canal',
        route: '/pipeline-canales',
        icon: NavIcons.settings,
        profiles: ['administrador'],
      },
      {
        label: 'Matriz de campos',
        route: '/matriz-campos',
        icon: NavIcons.settings,
        profiles: ['administrador'],
      },
      {
        label: 'Período de gestión',
        route: '/periodo-gestion',
        icon: NavIcons.calendar,
        profiles: ['administrador'],
      },
    ],
  },
  {
    title: 'Control',
    profiles: ['administrador', 'soporte', 'jefe_comercial', 'director'],
    items: [
      {
        label: 'Auditoría',
        route: '/auditoria',
        icon: NavIcons.search,
        profiles: ['administrador', 'soporte', 'jefe_comercial', 'director'],
      },
    ],
  },
  {
    title: 'Sistema anterior (INVEB)',
    items: [
      {
        label: 'Equivalencias INVEB',
        route: '/equivalencias-inveb',
        icon: NavIcons.settings,
        profiles: ['administrador', 'jefe_comercial', 'director', 'soporte'],
      },
      {
        label: 'Migración INVEB',
        route: '/migracion-inveb',
        icon: NavIcons.settings,
        profiles: ['administrador', 'jefe_comercial', 'director', 'soporte'],
      },
    ],
  },
  {
    title: 'Integraciones',
    profiles: ['administrador', 'soporte'],
    items: [
      {
        label: 'Sincronización con Office 365',
        route: '/sincronizacion-office365',
        icon: NavIcons.calendar,
        profiles: ['administrador', 'soporte'],
      },
    ],
  },
];
